import type { LucideIcon } from "lucide-react";
import { Eye, Heart, MessageCircle, Share2, TrendingUp } from "lucide-react";
import type { TimeseriesDataV1, TimeseriesDataV2 } from "@shared/lib/types/reports";

export type ChartMetricKey = "views" | "likes" | "comments" | "shares";

export type MetricCardKey = ChartMetricKey | "engagement";

type ChartMetricConfig = {
  key: ChartMetricKey;
  label: string;
  chartTitle: { v1: string; v2: string };
  color: string;
  bg: string;
  icon: LucideIcon;
  getV1Value: (entry: TimeseriesDataV1[string]) => number;
  getV2Value: (entry: TimeseriesDataV2[string]) => number;
};

export const CHART_METRICS: Record<ChartMetricKey, ChartMetricConfig> = {
  views: {
    key: "views",
    label: "Total Views",
    chartTitle: {
      v1: "Views Growth",
      v2: "Views Growth (Delta)",
    },
    color: "#2563eb",
    bg: "#eff6ff",
    icon: Eye,
    getV1Value: (entry) => entry.views || 0,
    getV2Value: (entry) => entry.deltaViews || 0,
  },
  likes: {
    key: "likes",
    label: "Total Likes",
    chartTitle: {
      v1: "Likes Growth",
      v2: "Likes Growth (Delta)",
    },
    color: "#db2777",
    bg: "#fdf2f8",
    icon: Heart,
    getV1Value: (entry) => entry.likes || 0,
    getV2Value: (entry) => entry.deltaLikes || 0,
  },
  comments: {
    key: "comments",
    label: "Total Comments",
    chartTitle: {
      v1: "Comments Growth",
      v2: "Comments Growth (Delta)",
    },
    color: "#9333ea",
    bg: "#faf5ff",
    icon: MessageCircle,
    getV1Value: (entry) => entry.comments || 0,
    getV2Value: (entry) => entry.deltaComments || 0,
  },
  shares: {
    key: "shares",
    label: "Total Shares",
    chartTitle: {
      v1: "Shares Growth",
      v2: "Shares Growth (Delta)",
    },
    color: "#ea580c",
    bg: "#fff7ed",
    icon: Share2,
    getV1Value: (entry) => entry.shares || 0,
    getV2Value: (entry) => entry.deltaShares || 0,
  },
};

export const ENGAGEMENT_METRIC = {
  key: "engagement" as const,
  label: "Engagement Rate",
  color: "#16a34a",
  bg: "#f0fdf4",
  icon: TrendingUp,
  clickable: false as const,
};

export const DEFAULT_CHART_METRIC: ChartMetricKey = "views";
